import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import React, { useEffect, useState } from "react";
import { QueryParams } from "../../../models/signupParam";

const useStyles = makeStyles((theme) => ({
  actions: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
}));

export default function Filter({
  onFilter,
  params,
  className,
}: {
  onFilter: (params: QueryParams) => void;
  params: QueryParams;
  className?: string;
}) {
  const classes = useStyles();

  const [name, setName] = useState<string>("");
  const [paramsFilter, setParamsFilter] = useState<string>("");
  const [excludeNoProfile, setExcludeNoProfile] = useState<string>("");
  const [hasSignupParamOnly, setHasSignupParamOnly] = useState<string>("");

  useEffect(() => {
    setName(params.name || "");
    setParamsFilter(params.params || "");
    setExcludeNoProfile(params.excludeNoProfile ? "true" : "");
    setHasSignupParamOnly(params.hasSignupParamOnly ? "true" : "");
  }, [params]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onFilter({
      name: name || undefined,
      params: paramsFilter || undefined,
      excludeNoProfile: excludeNoProfile === "true" ? true : undefined,
      hasSignupParamOnly: hasSignupParamOnly === "true" ? true : undefined,
    });
  };

  const handleReset = () => {
    onFilter({});
  };

  return (
    <Card className={className}>
      <CardContent>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="氏名"
                variant="outlined"
                fullWidth
                size="small"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="パラメータ検索"
                variant="outlined"
                fullWidth
                size="small"
                value={paramsFilter}
                onChange={(e) => setParamsFilter(e.target.value)}
              />
            </Grid>
            <Grid item xs={6} sm={4} md={2}>
              <TextField
                label="プロフィール未設定を除外"
                variant="outlined"
                fullWidth
                size="small"
                select
                SelectProps={{ native: true }}
                InputLabelProps={{ shrink: true }}
                value={excludeNoProfile}
                onChange={(e) => setExcludeNoProfile(e.target.value)}
              >
                <option value="">指定なし</option>
                <option value="true">はい</option>
              </TextField>
            </Grid>
            <Grid item xs={6} sm={4} md={2}>
              <TextField
                label="登録パラメータ"
                variant="outlined"
                fullWidth
                size="small"
                select
                SelectProps={{ native: true }}
                InputLabelProps={{ shrink: true }}
                value={hasSignupParamOnly}
                onChange={(e) => setHasSignupParamOnly(e.target.value)}
              >
                <option value="">全て</option>
                <option value="true">ありのみ</option>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={4} md={2}>
              <div className={classes.actions}>
                <Button
                  color="primary"
                  type="submit"
                  variant="contained"
                  size="small"
                >
                  絞り込む
                </Button>
                <Button
                  color="default"
                  variant="outlined"
                  size="small"
                  onClick={handleReset}
                >
                  リセット
                </Button>
              </div>
            </Grid>
          </Grid>
        </form>
      </CardContent>
    </Card>
  );
}
